import { takeEvery, takeLatest, put, select } from 'redux-saga/effects'
import { getCareteamsFromPatientId } from '../Careteam/ducks'
import { getCurrentPatient } from '@medeo/patients'
import { getAccessToken } from '@medeo/user'
import {
  LOADING_CAREPLANS,
  CREATING_CAREPLAN,
  receiveCarePlans
} from './actions'

const URL = process.env.FHIR_URL

export default function* rootSaga() {
  yield takeEvery(LOADING_CAREPLANS, loadCarePlans)
  yield takeLatest(CREATING_CAREPLAN, createCarePlan)
}

function* loadCarePlans(action) {
  const response = yield fetch(`${URL}/careplans`, {
    method: 'GET',
    header: {
      'Content-Type': 'application/json'
    }
  })
  const responseJSON = yield response.json()
  yield put(receiveCarePlans(responseJSON))
}

function* createCarePlan(action) {
  const { goals, frequencies, measuresTypes } = action.payload
  const accessToken = yield select(getAccessToken)
  const patient = yield select(getCurrentPatient)

  let sortedGoals = {}
  measuresTypes.map(type => {
    sortedGoals = {
      ...sortedGoals,
      [type]: goals.filter(
        goal => goal.target.measure.coding[0].display === type
      )
    }
    return type
  })
  const careteams = yield select(getCareteamsFromPatientId, patient.id)
  let carePlan = {
    resourceType: 'CarePlan',
    text: {
      status: 'generated'
    },
    identifier: [
      {
        use: 'official',
        system: 'http://www.bmc.nl/zorgportal/identifiers/careplans',
        value: 'CP2903'
      }
    ],
    status: 'completed',
    intent: 'plan',
    subject: {
      reference: `Patient/${patient.id}`,
      identifier: {
        value: patient.id
      }
    },
    period: {
      start: new Date()
    },
    careTeam: careteams.map(careteam => ({
      reference: `Careteam/${careteam.id}`,
      identifier: {
        value: careteam.id
      }
    })),
    activity: measuresTypes.map(type => ({
      detail: {
        status: 'completed',
        goal: sortedGoals[type].map(goal => {
          const identifier = {
            reference: `Goal/${goal.id}`,
            identifier: {
              value: goal.id
            }
          }
          return identifier
        }),
        performer: [
          {
            identifier: {
              value: patient.id
            },
            reference: `Patient/${patient.id}`
          }
        ],
        scheduledTiming: createTiming(frequencies, type),
        description:
          sortedGoals[type].length > 0
            ? sortedGoals[type][0].target.measure.coding[0].display
            : ''
      }
    }))
  }

  try {
    const response = yield fetch(`${URL}/careplans`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken != null && { Authorization: `Bearer ${accessToken}` })
      },
      body: JSON.stringify(carePlan)
    })
    const careplan = yield response.json()
    yield put(receiveCarePlans([careplan]))
  } catch (error) {
    console.log('Error saving CarePlan', error)
  }
}

const createTiming = (frequencies, type) => {
  const frequency = frequencies.find(
    frequency => frequency.measureType === type
  )
  const weekDaysCodes = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

  return frequency
    ? {
        repeat: {
          boundsPeriod: {
            start: new Date(),
            end:
              parseFloat(frequency.duration) + frequency.durationUnit + ' after'
          },
          dayOfWeek: weekDaysCodes.filter(
            dayCode => weekDaysCodes.indexOf(dayCode) < frequency.timesPerWeek
          ),
          timeOfDay: [
            frequency.morning ? 'morning' : null,
            frequency.midday ? 'midday' : null,
            frequency.evening ? 'evening' : null
          ].filter(value => value !== null),
          when: [
            /* technically not correct*/
            frequency.timeDelay,
            frequency.timeDelayUnit,
            frequency.timeDelayComment
          ]
        }
      }
    : {}
}



// WEBPACK FOOTER //
// ./src/Careplan/sagas.js